import { useRef } from 'react';
import { Icon } from '@/lib/icons';
import type { translations } from '@/translations/translations';

interface Props {
  copy: typeof translations.fr.admin.excelFiles.themes.questions;
  isImporting: boolean;
  onImport: (file: File) => void;
}

export function ThemeQuestionWorkbookUpload({ copy, isImporting, onImport }: Props) {
  const input = useRef<HTMLInputElement>(null);
  return (
    <section className="flex flex-wrap items-center justify-between gap-4 rounded-xl border border-border/50 bg-background p-4 shadow-sm">
      <div className="space-y-1">
        <h3 className="text-sm font-semibold text-foreground">{copy.importTitle}</h3>
        <p className="max-w-xl text-xs leading-5 text-muted-foreground">{copy.importDescription}</p>
      </div>
      <input ref={input} type="file" accept=".xlsx,.xls" className="sr-only"
        aria-label={copy.importFile} onChange={(event) => {
          const file = event.target.files?.[0];
          if (file) onImport(file);
          event.target.value = '';
        }} />
      <button type="button" disabled={isImporting} onClick={() => input.current?.click()}
        className="inline-flex items-center gap-2 rounded-full bg-foreground px-4 py-2 text-xs font-semibold text-background disabled:opacity-40">
        <Icon name={isImporting ? 'loader2' : 'upload'} className={`h-4 w-4 ${isImporting ? 'animate-spin' : ''}`} />
        {isImporting ? copy.importing : copy.importFile}
      </button>
    </section>
  );
}
